import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSelect,{attrs:{"label":_vm.$t('SeedYear'),"items":_vm.seedYears,"value":_vm.value,"value-comparator":_vm.valueComparer,"rules":_vm.rules,"item-text":_vm.itemText,"item-value":_vm.itemValue,"clearable":_vm.clearable,"multiple":_vm.multiple,"error-messages":_vm.errorMessages,"disabled":_vm.disabled,"readonly":_vm.readonly},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }